import { BaseValidationRule, IValidateable } from '@aurelia/validation';

export class ValidLengthNumberPropertyRule extends BaseValidationRule {
  public constructor(private propertyName: string) {
    super();
  }

  public execute(value: any, _object?: IValidateable): boolean {
    return value === null ||
    value === undefined ||
    value === "" ||
    (value.length === 3 && !isNaN(Number(value))) ||
    (value.length === 4 && !isNaN(Number(value)));
  }
}
